export const ANALYTICS_PAGE_CLICK = 'customersTable';
export const ANALYTICS_EVENT_ACTION = 'changed';
export const ANALYTICS_EVENT_SUBJECT = 'pageNumber';
